export default "__VITE_ASSET__viooKiGi__"